import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { OrdersService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TOrder, TOrderItem } from '@shared/models';

@Component({
    'selector': 'app-order',
    'templateUrl': './order.page.html',
    'styleUrls': ['./order.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class OrderPage extends ViewBasePage implements OnInit, OnDestroy {
    public order: TOrder = null;    // { billing: {}, header: {}, items: [], shipping: {} };
    public orderItems: TOrderItem[] = null;

    constructor(private ordersService: OrdersService, private activatedRoute: ActivatedRoute, injector: Injector) {
        super(injector);
        super.setCurrentView(this.Constants.VIEW_ORDER);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        try {
            const uid = this.activatedRoute.snapshot.paramMap.get('uid');
            if (uid) {
                this.uxHelperService.showSpinner();
                this.order = await this.ordersService.getByUid(uid);
                this.orderItems = this.order.items;
                // console.log('order = ', this.order);

                // this.order.header.createdDateFormatted = this.dateService.reformatDateTime(this.order.header.createdDate.date);
                this.order.header.totalFormatted = this.utilsService.formatAsCurrency(this.order.header.total);

                this.order.items.forEach((item) => {
                    item.unitPriceFormatted = this.utilsService.formatAsCurrency(item.unitPrice);
                    item.taxFormatted = this.utilsService.formatAsCurrency(item.tax);
                    item.subtotalFormatted = this.utilsService.formatAsCurrency(item.subtotal);
                    item.totalFormatted = this.utilsService.formatAsCurrency(item.total);
                });

                this.uxHelperService.hideSpinner();
            }
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error!', errorMessage);
        }
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public getGrandTotalFormatted() {
        const value = this.order?.header?.total;
        if (value) {
            const valueFormatted = this.utilsService.formatAsCurrency(value);
            return valueFormatted;
        } else {
            return '$0.00';
        }
    }

    public getOrderNote() {
        const value = this.order?.header?.description;
        if (value) {
            return value;
        } else {
            return '';
        }
    }

    // public getNote() {
    //     const value = this.order?.header?.notes;
    //     if (value) {
    //         return value;
    //     } else {
    //         return '';
    //     }
    // }

    public getItemTotalFormatted(item: TOrderItem) {
        const value = item.total;
        if (value) {
            const valueFormatted = this.utilsService.formatAsCurrency(value);
            return valueFormatted;
        } else {
            return '$0.00';
        }
    }

    public getTaxFormatted(item: TOrderItem) {
        const value = item.tax;
        if (value) {
            const valueFormatted = this.utilsService.formatAsCurrency(value);
            return valueFormatted;
        } else {
            return '$0.00';
        }
    }

    public getSubtotalFormatted(item: TOrderItem) {
        const value = item.subtotal;
        if (value) {
            const valueFormatted = this.utilsService.formatAsCurrency(value);
            return valueFormatted;
        } else {
            return '$0.00';
        }
    }

    public getUnitPriceFormatted(item: TOrderItem) {
        const value = item.unitPrice;
        if (value) {
            const valueFormatted = this.utilsService.formatAsCurrency(value);
            return valueFormatted;
        } else {
            return '$0.00';
        }
    }

    public getOrderId() {
        const value = this.order?.header?.orderId;
        if (value) {
            return value;
        } else {
            return '';
        }
    }

    public getPurchasedDate() {
        let str = '';

        const ts = this.order.header.createdDate?.date;
        if (ts) {
            str = this.dateService.formatTimestamp(ts);
        }

        return str;

        // let value = this.order.header.createdDate?.date;
        // if (value) {
        //     const pos = value.lastIndexOf('.');
        //     value = value.substring(0, pos);            
        //     if (value) {
        //         const valueFormatted = this.dateService.formatTimestamp(value);
        //         return valueFormatted;
        //     } else {
        // }
    }
}
